var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 42,
    viewBox: "0 0 82 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81 1C68.0026 2.08312 67.1977 28.0136 54.3333 31C43.7251 33.4626 38.3534 19.4836 27.6667 21C16.0752 22.6447 12.3659 37.2114 1 41H81V1Z",
    fill: "#ECFDF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 1C68.0026 2.08312 67.1977 28.0136 54.3333 31C43.7251 33.4626 38.3534 19.4836 27.6667 21C16.0752 22.6447 12.3659 37.2114 1 41H81V1Z",
    fill: "url(#paint0_linear_8482_23147)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 41C12.3659 37.2114 16.0752 22.6447 27.6667 21C38.3534 19.4836 43.7251 33.4626 54.3333 31C67.1977 28.0136 68.0026 2.08312 81 1",
    stroke: "#12B76A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8482_23147",
    x1: 41,
    y1: 1,
    x2: 41,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.641167,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSuccess);
export default __webpack_public_path__ + "static/media/chart-success.bc9023176d3560c878e1cb7ab35b859b.svg";
export { ForwardRef as ReactComponent };